/*eslint-disable */
import React from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Container } from "semantic-ui-react";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import MyState from '../../components/apiInputs/myState.js'

const InsertVehicleType = ({ values, touched, errors, t ,editData}) => (
  <React.Fragment>
    <Formiker>
      <div className="container-fluid animated slideInDown pad w3-white">
        <div className="m-3 pl-3">
          <div className="ui form">
            <FormUi.Group inline>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.city_code.title") || "City Code"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={touched.cityCode && errors.cityCode ? true : false}
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="cityCode"
                  placeholder={t("create.city_code.placeholder") || "Enter City Code"}
                />
                {touched.cityCode && errors.cityCode ? (
                  <div className="error-msg">
                    {t(`create.city_name.error_msg.${errors.cityCode}`) ||
                      errors.cityCode}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.city_name.title") || "City Name"} <span className="red">*</span>
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={touched.cityName && errors.cityName ? true : false}
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="cityName"
                  placeholder={t("create.city_name.placeholder") || "City Name"}
                />
                {touched.cityName && errors.cityName ? (
                  <div className="error-msg">
                    {t(`create.city_name.error_msg.${errors.cityName}`) ||
                      errors.cityName}
                  </div>
                ) : null}
              </FormUi.Field>
              
            </FormUi.Group>
            <FormUi.Group inline>
              
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.latitude.title") || "Latitude"}
                </label>
              </FormUi.Field>
              <FormUi.Field
              className="display-grid-center-imp"
                width={4}
                error={touched.lat && errors.lat ? true : false}
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="lat"
                  placeholder={t("create.latitude.placeholder") || "Latitude"}
                />
                {touched.lat && errors.lat ? (
                  <div className="error-msg">
                    {t(`create.latitude.error_msg.${errors.lat}`) || errors.lat}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.longitude.title") || "Longitude"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
                error={touched.lng && errors.lng ? true : false}
              >
                <Fieldmik
                  type="text"
                  className="ui input"
                  name="lng"
                  placeholder={t("create.longitude.placeholder") || "Longitude"}
                />
                {touched.lng && errors.lng ? (
                  <div className="error-msg">
                    {t(`create.longitude.error_msg.${errors.lng}`) ||
                      errors.lng}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field width={2}>
                <label className="labelName">
                  {t("create.state.title") || "State"} <span className="red">*</span>
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                className="display-grid-center-imp"
              >
                <Fieldmik
                  type="text"
                  component={MyState}
                  name="stateId"
                  stateNameField="stateName"
                  placeholder={editData.stateName || t("create.state.placeholder")}
                />
                {touched.stateId && errors.stateId ? (
                  <div className="error-msg">
                    {t(`create.city_name.error_msg.${errors.stateId}`) ||
                      errors.stateId}
                  </div>
                ) : null}
              </FormUi.Field>
              
            </FormUi.Group>
          </div>
        </div>
      </div>
      <Container className="p-3" textAlign="center">
        <button
          className="w3-button w3-blue w3-hover-blue w3-round w3-small"
          type="submit"
        >
          {t("action_button.submit") || "Submit"}
        </button>
      </Container>
    </Formiker>
  </React.Fragment>
);

const FormikVehicleType = withFormik({
  validationSchema: yup.object({
    cityName: yup.string().required("required"),
    stateId: yup.string().required("required"),
    lat: yup
      .string()
      // .required("required")
      .matches(AllRegex.Latitude, "latitude"),
    lng: yup
      .string()
      // .required("required")
      .matches(AllRegex.Longitude, "longitude"),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    cityCode : props.editData.cityCode || "",
    cityName: props.editData.cityName || "",
    stateId: props.editData.stateId || "",
    lat: props.editData.lattitude || "",
    lng: props.editData.longitude || "",
    stateName: props.editData.stateName || "",
  }),
  async handleSubmit(values, { props }) {
    if (props.editData.city_id) {
      await UpdateAxios({
        url: "cityMaster",
        payload: { ...values },
        uniqueId: props.editData.city_id,
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      await CreatAxios({
        url: "cityMaster",
        payload: { ...values },
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          props.successAlertDispatcher(alert);
        });
    }
  },
})(InsertVehicleType);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate("city")(FormikVehicleType));
